import React from "react";
import "../styles/About.css";

import ceoPhoto from "../images/CEO.png"
import DS from "../images/DS.png"
import head from "../images/head.png"
import {Link} from "react-router-dom";

const About = () => {
    return (
        <div className="about-page">
            {/* Hero Section */}
                <div className="about-hero">
                    <h1>About Curve Intel</h1>
                    <p>
                        Empowering businesses to make smarter, data-driven decisions through cutting-edge analytics.
                    </p>
                </div>

            <div className={"hero-section"}>
                {/* Mission Statement Section */}
                <div className="mission-statement">
                    <h2>Our Mission</h2>
                    <p>
                        At Curve Intel, we are dedicated to turning complex data into actionable insights.
                        Our goal is to help organizations navigate uncertainty, uncover opportunities, and achieve sustainable growth.
                    </p>
                </div>
                <div className="who-we-are">
                    <div className="who-we-are-content">
                        <h2>An Alliance</h2>
                        <p>
                            We become more than just a partner—we’re your trusted ally.
                            We align with your goals, tackle your challenges head-on, and empower your team
                            with actionable insights and innovative strategies. Your success is our priority,
                            and we’re here to help you navigate complexity, unlock potential, and drive sustainable growth.
                        </p>
                    </div>
                </div>
            </div>

            {/* Team Section */}
            {/*
            <div className="team-section">
                <h2>Meet Our Team</h2>
                <div className="team-grid">
                    <div className="team-member">
                        <img src={ceoPhoto} alt="Team Member" />
                        <h3>Jon Doe</h3>
                        <p>CEO & Founder</p>
                    </div>
                    <div className="team-member">
                        <img src={head} alt="Team Member" />
                        <h3>James RasClarance</h3>
                        <p>Head of Analytics</p>
                    </div>
                    <div className="team-member">
                        <img src={DS} alt="Team Member" />
                        <h3>Mary Smith</h3>
                        <p>Lead Data Scientist</p>
                    </div>
                </div>
            </div>
            */}

            {/* History / What We Do Section */}
            <div className="history-section">
                <h2>What We Do</h2>
                <p>
                    Founded in 2023, Curve Intel specializes in advanced data analytics, predictive modeling, and
                    decision-making solutions. Our expertise spans various industries, including finance, healthcare, and technology.
                </p>
            </div>

            {/* Call to Action */}
            <div className="about-cta">
                <Link to="/contact"><button>Let's Connect!</button></Link>
            </div>
        </div>
    );
};

export default About;
